import { render, staticRenderFns } from "./HistoricoPagamentoFornecedor.vue?vue&type=template&id=f92b9f96&scoped=true&"
import script from "./HistoricoPagamentoFornecedor.vue?vue&type=script&setup=true&lang=js&"
export * from "./HistoricoPagamentoFornecedor.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92b9f96",
  null
  
)

export default component.exports